export interface Repo {
  org: string;
  repo: string;
  last_verdict_at: string | null;
}

export type SortKey = 'org' | 'repo' | 'last_verdict_at';
export type SortDir = 'asc' | 'desc';

export interface FilterAndSortOptions {
  orgFilter: string;
  search: string;
  sortKey: SortKey;
  sortDir: SortDir;
  hideNoVerdict: boolean;
}

export function compareRepos(a: Repo, b: Repo, key: SortKey, dir: SortDir): number {
  // Null last_verdict_at always sorts to the bottom regardless of direction —
  // matches data-grid conventions for "no data" values.
  if (key === 'last_verdict_at') {
    const aNull = a.last_verdict_at === null;
    const bNull = b.last_verdict_at === null;
    if (aNull && bNull) return 0;
    if (aNull) return 1;
    if (bNull) return -1;
  }
  const av = a[key] ?? '';
  const bv = b[key] ?? '';
  const cmp = av < bv ? -1 : av > bv ? 1 : 0;
  return dir === 'asc' ? cmp : -cmp;
}

export function filterAndSort(rows: readonly Repo[], opts: FilterAndSortOptions): Repo[] {
  const needle = opts.search.trim().toLowerCase();
  const filtered = rows.filter(r => {
    if (opts.orgFilter && r.org !== opts.orgFilter) return false;
    if (needle && !r.repo.toLowerCase().includes(needle)) return false;
    if (opts.hideNoVerdict && r.last_verdict_at === null) return false;
    return true;
  });
  return [...filtered].sort((a, b) => compareRepos(a, b, opts.sortKey, opts.sortDir));
}
